function JobQuoteValidation (cvalidation) {
    this.cvalidation = cvalidation;

    // methods
    this.generateGlobalErrorMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        if (this.cvalidation.hasGlobalErrorMessages) {
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            content += '<ul class="validationErrorMessage">';
            for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                var cmessage = globalErrorMessages[i];
                content += '<li>' + cmessage.value + '</li>';
            }
            content += '</ul>';
        }
        return content;
    };
    this.generateGlobalInfoMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        if (this.cvalidation.hasGlobalInfoMessages) {
            var globalInfoMessages = this.cvalidation.globalInfoMessages;
            content += '<ul class="validationInfoMessage">';
            for (var i = 0, ni = globalInfoMessages.length; i < ni; i++) {
                var cmessage = globalInfoMessages[i];
                content += '<li>' + cmessage.value + '</li>';
            }
            content += '</ul>';
        }
        return content;
    };
    this.generateGlobalMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        content += this.generateGlobalErrorMessages();
        content += this.generateGlobalInfoMessages();
        return content;
    };
    this.hasJobQuoteFieldMessagesFor = function (fieldName) {
        if (this.cvalidation == null) {
            return false;
        }
        if (this.cvalidation.jobQuoteFieldMessages == null) {
            return false;
        }
        var fieldMessages = this.cvalidation.jobQuoteFieldMessages;
        for (var i = 0; i < fieldMessages.length; i++) {
            var fieldMessage = fieldMessages[i];
            if (fieldMessage.fieldName == fieldName) {
                return true;
            }
        }
        return false;
    };
    this.generateJobQuoteFieldMessagesFor = function (fieldName) {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        var fieldMessages = this.cvalidation.jobQuoteFieldMessages;
        content += '<div class="fieldErrorNote">';
        for (var i = 0; i < fieldMessages.length; i++) {
            var fieldMessage = fieldMessages[i];
            if (fieldMessage.fieldName == fieldName) {
                content += fieldMessage.value + ' ';
            }
        }
        content += '</div>';
        return content;
    };
    this.generateFullSummary = function () {
        var content = '';
        if (this.cvalidation != null && (this.cvalidation.globalMessages != null || this.cvalidation.jobQuoteFieldMessages != null)) {
            content += '<ul>';
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            if (globalErrorMessages != null) {
                for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                    var cmessage = globalErrorMessages[i];
                    content += '<li>' + cmessage.value + '</li>';
                }
            }
            var globalInfoMessages = this.cvalidation.globalInfoMessages;
            if (globalInfoMessages != null) {
                for (var i = 0, ni = globalInfoMessages.length; i < ni; i++) {
                    var cmessage = globalInfoMessages[i];
                    content += '<li>' + cmessage.value + '</li>';
                }
            }
            var fieldMessages = this.cvalidation.jobQuoteFieldMessages;
            if (fieldMessages != null) {
                for (var i = 0, ni = fieldMessages.length; i < ni; i++) {
                    var fieldMessage = fieldMessages[i];
                    content += '<li>' + fieldMessage.fieldName + ' ' + fieldMessage.value + '</li>';
                }
            }
            content += '</ul>';
        }

        return content;
    };
    this.setValidationErrorReasons = function (validator) {
        if (this.cvalidation != null) {
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            if (globalErrorMessages != null) {
                for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                    var cmessage = globalErrorMessages[i];
                    validator.addItem({
                        isValid: function () {
                            return false;
                        },
                        reason: cmessage.value
                    });
                }
            }
            var fieldMessages = this.cvalidation.jobQuoteFieldMessages;
            if (fieldMessages != null) {
                for (var i = 0, ni = fieldMessages.length; i < ni; i++) {
                    var cmessage = fieldMessages[i];
                    validator.addItem({
                        isValid: function () {
                            return false;
                        },
                        reason: cmessage.value
                    });
                }
            }
        }
    };
    this.buildWarningList = function (quoteResponse) {
        if (quoteResponse && quoteResponse.messages) {
            var quoteWarnings = quoteResponse.messages.find(function (message) {
                return message.type === 'WARNING' && message.detail.startsWith('Quote Warnings:');
            });

            if (quoteWarnings) {
                return this.extractBracketContents(quoteWarnings.detail);
            }
        }
        return [];
    };
    this.extractBracketContents = function (str) {
        var matches = str.match(/\[([^\]]+)]/g);
        if (!matches) {
            return [];
        }

        var result = [];
        for (var i = 0; i < matches.length; i++) {
            result.push(matches[i].slice(1, -1));
        }

        return result;
    };
}
